export enum ReassignDisputeFormNamesEnum {
  REASON_CODE = 'ReasonCode',
  REASON_FOR_REASSIGNMENT = 'ReasonForReassignment',
}
